import React from 'react'
import Button from "@material-tailwind/react/Button";
import H2 from "@material-tailwind/react/Heading2";
import '../CSS/Depression_test.css'
import { Link } from 'react-router-dom'
import { useStateValue } from '../StateProvider';
import NavOnlyIcons from './NavOnlyIcons';

const Depression_test = () => {

    const [{user}] = useStateValue();

    return (
        <div className="depressionDiv">
            <div className="dipNav">
                <NavOnlyIcons /> 
                
            </div>
            <div className="depDiv">
                <div className="depressionInnerDiv1">
                
                    <div className="depressionLeftDiv">
                        <H2 id='depressionTestHead'>Depression test</H2>
                        <p>
                        Wondering if it’s just a phase or something more? 
                        Take our short online test to find out if you’re living 
                        with depression.Get started
                        </p>
                        <Link to={user ? '/take_test' : '/login_Signup'}> 
                            <Button color="lightBlue" size="lg" ripple="light">Get started</Button>
                        </Link>
                    </div>

                    <div className="depressionRightDiv">
                    
                    </div>

                </div>
                
            </div>
        </div>
    )
}

export default Depression_test
